(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["obituary-checkout-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('obituary-checkout-offer');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  window.addEventListener('keydown', event => {
    if (dialog.open && event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); dialog.close(); }
  }, true);
  let pending = null;
  let bypass = false;
  let opener = null;
  const show = (event, action, trigger) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (dialog.open) return;
    pending = action;
    opener = trigger;
    dialog.showModal();
    dialog.querySelector('.obituary-offer-add').focus();
  };
  document.addEventListener('click', event => {
    if (bypass || !(event.target instanceof Element)) return;
    const button = event.target.closest('button[name="checkout"],input[name="checkout"],a[href]');
    if (!button || button.closest('#obituary-checkout-offer') || button.disabled) return;
    if (button instanceof HTMLAnchorElement) {
      const url = new URL(button.href, location.href);
      if (url.origin !== location.origin || !/\/(checkout|checkouts)\/?$/.test(url.pathname)) return;
      show(event, () => location.assign(url.href), button);
    } else {
      if (button.form && !button.form.reportValidity()) { event.preventDefault(); return; }
      show(event, () => button.click(), button);
    }
  }, true);
  document.addEventListener('submit', event => {
    if (bypass || !(event.target instanceof HTMLFormElement)) return;
    const button = event.submitter;
    if (button?.name !== 'checkout') return;
    const form = event.target;
    show(event, () => form.requestSubmit(button), button);
  }, true);
  dialog.querySelector('.obituary-offer-skip').addEventListener('click', () => {
    const resume = pending;
    pending = null;
    dialog.close();
    if (!resume) return;
    bypass = true;
    try { resume(); } finally { bypass = false; }
  });
  dialog.querySelector('.obituary-offer-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });
})();
  } catch(e) { console.error(e); }
})();

})();
